import React from 'react';
import ContentPage from './ContentPage';

// Content now lives in the content_pages table (#66); see ContentPage.js.
function Privacy() {
  return <ContentPage slug="privacy" title="Privacy Policy" />;
}

export default Privacy;
